import {Component, OnInit, Inject, NgZone} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DropdownModel } from '../../../dropdown/dropdown.model';
import { COMPONENT_MODE } from '../../../workflow-components.models';
import { CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'abw-inventory-input-articles-dialog',
    templateUrl: './inventory-input-articles-dialog.component.html',
    styleUrls: ['./inventory-input-articles-dialog.component.scss']
})
export class InventoryInputArticlesDialog implements OnInit {
    dropdownFormModel: DropdownModel;
    control = new FormControl(null, [Validators.required]);
    datas: any[] = [];
    valueName: string;
    displayName: string;

    constructor(
        public dialogRef: MatDialogRef<InventoryInputArticlesDialog>,
        @Inject(MAT_DIALOG_DATA) private data: { datas: any[], valueName: string, displayName: string },
    ) {
        this.datas = data.datas;
        this.valueName = data.valueName;
        this.displayName = data.displayName;
    }

    ngOnInit() {
        this.dropdownFormModel = DropdownModel.initModel({
            ID: 'AR_Ref',
            CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN,
            LABEL: 'Article',
            DEFAULT_VALUE: null,
            IS_REQUIRED: true,
            IS_READONLY: false,
            IS_VISIBLE: true,
            CUSTOM_VALIDATORS: [],
            COMPONENT_MODE: COMPONENT_MODE.EXECUTION,
            RELATIONS: []
        }, {
            DATASOURCE_DATAS: this.datas,
            DATASOURCE_FILTERED_DATAS: this.datas,
            DATASOURCE_VALUE_FIELD: this.valueName,
            DATASOURCE_DISPLAY_FIELD: this.displayName
        });
    }
    
    dismiss() {
        this.dialogRef.close(false);
    }

    onSubmit() {
        if (!this.control.valid) { return; }
        this.dialogRef.close(this.control.value);
    }
}